var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './AddressPage.module.css';
import { useMemo } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import styled from 'styled-components';
var StepElement = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 2px;\n  width: 24px;\n  margin: 0 2px;\n  border-radius: 2px;\n  background-color: ", ";\n"], ["\n  height: 2px;\n  width: 24px;\n  margin: 0 2px;\n  border-radius: 2px;\n  background-color: ", ";\n"])), function (props) {
    return props.isStepActive
        ? props.theme.colors.textBodyAdd
        : props.theme.colors.dieDefault;
});
var StepWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n"], ["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n"])));
export var InformationScreens = function (_a) {
    var label = _a.label, text = _a.text, stepNumber = _a.stepNumber, stepsCount = _a.stepsCount, other = __rest(_a, ["label", "text", "stepNumber", "stepsCount"]);
    var stepsToView = useMemo(function () {
        return Array.from(Array(stepsCount)).map(function (item, index) { return index + 1 === stepNumber; });
    }, [stepNumber, stepsCount]);
    return (_jsxs(PageLayout, __assign({}, other, { children: [_jsx("h2", __assign({ className: styles.title }, { children: label })), _jsx("p", __assign({ className: styles.text }, { children: text })), _jsx("img", { alt: "Step \u2116".concat(stepNumber), style: { height: 216, width: '100%' }, src: "./public/asset/steps/pic_step_".concat(stepNumber, ".png") }), _jsx(StepWrapper, { children: stepsToView.map(function (isActive, index) { return (_jsx(StepElement, { isStepActive: isActive }, index)); }) })] })));
};
var templateObject_1, templateObject_2;
